export const Base_Url = 'https://1412api.bionet.az/api/';
// export const Base_Url = 'http://localhost:8000/api';